/* Publish by EComposer at 2026-09-29 05:01:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n78prju0z2"]=  window.__ectimmers["ecom-n78prju0z2"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-n78prju0z2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n78prju0z2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsxupoyiouq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsxupoyiouq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02huisqafx09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02huisqafx09', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6yc87s641f4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6yc87s641f4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-485zwahtfmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-485zwahtfmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8a2zepiz22w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8a2zepiz22w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u2feuyuc7fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u2feuyuc7fk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4jweurst45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4jweurst45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i59p97wfzuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i59p97wfzuk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcxai7zynpq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcxai7zynpq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40pud7ee8fx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40pud7ee8fx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ywydna0uv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ywydna0uv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gm2sgfwyho6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gm2sgfwyho6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wcrwu2bkb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wcrwu2bkb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqbyifi8lv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqbyifi8lv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mk3dfcto0b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mk3dfcto0b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mg3c4280yh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mg3c4280yh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jb7pmymikw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jb7pmymikw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l386wwe5pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l386wwe5pl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2io644ugkdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2io644ugkdd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ruwhc9jv48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruwhc9jv48', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cnrdt5v6sh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cnrdt5v6sh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wiulz2n4g7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wiulz2n4g7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hw8db1mn69v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hw8db1mn69v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ji7q61i0sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ji7q61i0sj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grcz3g1y73q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grcz3g1y73q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5f1b5si7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5f1b5si7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpc4z14tsge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpc4z14tsge', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrn2kdu8wj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrn2kdu8wj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-512c4039oo3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-512c4039oo3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnery1wceu5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnery1wceu5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9wp9gf8y0mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9wp9gf8y0mh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0cpoocxbv9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0cpoocxbv9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iolfs45z5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iolfs45z5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxx2hsmcevr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxx2hsmcevr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqv0alu6f0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqv0alu6f0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yr9dwq9r1cc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yr9dwq9r1cc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t6ac6bu37eo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t6ac6bu37eo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5mf35ztgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5mf35ztgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3o1h758tsjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3o1h758tsjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eizsjpu6g2u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eizsjpu6g2u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6p9of28zw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6p9of28zw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-370fn2den2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-370fn2den2r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q50qi1qdxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q50qi1qdxh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ope9cwlsva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ope9cwlsva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4rjh4qfmk2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rjh4qfmk2g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-503mksriczr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-503mksriczr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unfzf8jo7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unfzf8jo7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f0jfzu39q8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f0jfzu39q8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wxomgw0bcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wxomgw0bcv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-if510pk0m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-if510pk0m4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf7nxsu27i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf7nxsu27i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwqb4i48i5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwqb4i48i5n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbmxl42h2zw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbmxl42h2zw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d944ukqjb1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d944ukqjb1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x2epe3n65n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x2epe3n65n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p92s3sge9v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p92s3sge9v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p6jwew074f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p6jwew074f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v9smdnoluyk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v9smdnoluyk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w92nq6nolx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w92nq6nolx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hse3kjv3l1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hse3kjv3l1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnrag44v8b4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnrag44v8b4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfyrrnq2j5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfyrrnq2j5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pthqra2q37j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pthqra2q37j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzbld5cnxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzbld5cnxc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62wli9mi7cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62wli9mi7cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inxbel7bt1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inxbel7bt1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-81ks3zh35ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-81ks3zh35ug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8w16l6nmye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8w16l6nmye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfrjynl0nso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfrjynl0nso', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4teffsoewxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4teffsoewxu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iw50rgcripa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iw50rgcripa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ba6hl0ly43').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ba6hl0ly43', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfmn401rrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfmn401rrc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-shscvgu6r1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-shscvgu6r1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxirdtk6s7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxirdtk6s7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ah2x4vy4b4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ah2x4vy4b4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fvf76lzxpbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fvf76lzxpbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dkkzm5hf2aq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dkkzm5hf2aq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spycgo6bf6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spycgo6bf6d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x8r4bb9yfqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x8r4bb9yfqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bylzd8dvds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bylzd8dvds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aha41xaf34f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aha41xaf34f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd2sss3espl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd2sss3espl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyd9r0g2tp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyd9r0g2tp8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlkeebikbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlkeebikbo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qqvqidf2eb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qqvqidf2eb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4as0js6uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4as0js6uj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3pzm6fgvesg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3pzm6fgvesg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7k49ih95h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7k49ih95h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccgzieomwn6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccgzieomwn6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ic6mlpae3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ic6mlpae3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wdb73k1h3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdb73k1h3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a77aizdht1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a77aizdht1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iu4ca2txzwb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iu4ca2txzwb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgu7ooo3rho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgu7ooo3rho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97h6q7envb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97h6q7envb9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ya7di0yapy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ya7di0yapy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xqiy4h7c4to').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xqiy4h7c4to', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v0kmqa3dyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v0kmqa3dyf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tot2hj7acd"]=  window.__ectimmers["ecom-tot2hj7acd"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-tot2hj7acd"]["0pvdr3oik"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-tot2hj7acd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tot2hj7acd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8vjmp645da').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8vjmp645da', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g878zngwvvl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g878zngwvvl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bdqftlbj0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bdqftlbj0s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwk9bohli5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwk9bohli5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8olwxc7co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8olwxc7co', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwbsgowk1wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwbsgowk1wa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3yi539hcnjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3yi539hcnjc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-agf7xj3qbad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-agf7xj3qbad', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xi9so66zn5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xi9so66zn5j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8uqh3ewtjd3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8uqh3ewtjd3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-17vily13l3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-17vily13l3h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2gdgg726ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2gdgg726ws', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjnsyavpwjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjnsyavpwjj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-551zzlh3p79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-551zzlh3p79', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czw0or1cjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czw0or1cjm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qm4fnbr425').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qm4fnbr425', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucmw69nt8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucmw69nt8c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jxr7wg287rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jxr7wg287rp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4y901jpd2by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4y901jpd2by', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7b6vcyh5w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7b6vcyh5w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hu694n8comb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hu694n8comb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9s8595533p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9s8595533p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njqwpa2veo8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njqwpa2veo8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ecaen7xvqgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ecaen7xvqgo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xxxk985y34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xxxk985y34', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nebvddeejn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nebvddeejn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mcsnt6t8l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mcsnt6t8l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mik9ta6hx5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mik9ta6hx5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hq6tgxa731t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hq6tgxa731t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fpboziq0x2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fpboziq0x2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pn0innoixan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pn0innoixan', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hd5ufr3uowe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hd5ufr3uowe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbr3zjsgh4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbr3zjsgh4e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bljjr5j66h9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bljjr5j66h9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tmz93lf77a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tmz93lf77a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6as0fzrituk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6as0fzrituk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18pj1bewx27i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18pj1bewx27i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tuwzwea03g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tuwzwea03g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zrhw1s9jwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zrhw1s9jwk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f7ru2xf2spe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f7ru2xf2spe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kx5t98nusrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kx5t98nusrk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8us7ueyiai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8us7ueyiai', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kudu5rtlq5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kudu5rtlq5o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sx3e1i48h3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sx3e1i48h3l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhfy4744ghq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhfy4744ghq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z60hu4ssp2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z60hu4ssp2j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0kdne4xz5xtb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0kdne4xz5xtb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn1q2tosn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn1q2tosn9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1rca1ap45e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1rca1ap45e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7qt09mgv6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7qt09mgv6c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4rwgulyjvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4rwgulyjvb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1j7kptp4hr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1j7kptp4hr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he6zum1p6ie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he6zum1p6ie', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgy3eanucfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgy3eanucfm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wok03vecg4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wok03vecg4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpqjw4dqzdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpqjw4dqzdf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ltlnkjda90f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ltlnkjda90f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55bbrogexlx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55bbrogexlx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utxn7zbdt3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utxn7zbdt3s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eyh2mg9vsjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eyh2mg9vsjf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pcy349r6cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pcy349r6cm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jhda0d8kaoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jhda0d8kaoa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znkauoeoge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znkauoeoge', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zhxu27rqkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zhxu27rqkp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47t84zmtc0y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47t84zmtc0y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4m5z59jfztr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4m5z59jfztr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nk1k7rfdbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nk1k7rfdbw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxdl5y7aqsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxdl5y7aqsa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pyh0zp4wug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pyh0zp4wug', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbtrcc352wm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbtrcc352wm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64ec5mv9ech').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64ec5mv9ech', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdofqvtgc8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdofqvtgc8r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1s6pozuaydzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1s6pozuaydzh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5bieo3ukus').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5bieo3ukus', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tda9umbzo1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tda9umbzo1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxmcln6jipp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxmcln6jipp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vjs9m9fkr3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjs9m9fkr3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6avhtnctg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6avhtnctg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1m4icxcrs19"]=  window.__ectimmers["ecom-1m4icxcrs19"] || {};
var E,C,I,A,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=(C=this.settings.disable_auto_close__tablet)!=null?C:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(A=this.settings.scroll_on_mobile)!=null?A:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function W(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(W)}window.requestAnimationFrame(W)}function k(L){w(v(L)-100)}function $(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const W=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||W)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}$(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>$(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-1m4icxcrs19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1m4icxcrs19', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n0f9y2f5r0s"]=  window.__ectimmers["ecom-n0f9y2f5r0s"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(C){let I={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,I).observe(C)}function y(C,I){let A={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){C.readyState>=c&&C.pause()}function T(){C.readyState>=c&&C.play()}function L(){v(C,A)}if(r){C.addEventListener("mouseenter",j),C.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),I||C.addEventListener("ended",L)}}function v(C,I){if(I){const{handleMouseenter:A,handleMouseleave:j,handleEnded:T}=I;let L=t.querySelector(".ecom-video_link-extra");C.removeEventListener("mouseenter",A),C.removeEventListener("mouseleave",j),C.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",A),L.removeEventListener("mouseleave",j))}}function w(C,I){C.forEach(function(A){if(A.isIntersecting){const j=A.target.querySelector("video source"),T=A.target.querySelector("video"),L=A.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}I.unobserve(A.target)}})}let k=t.querySelector(".ecom_video"),$=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if($){let C=$.getAttribute("src");C.includes("autoplay=0")?C=C.replace("autoplay=0","autoplay=1"):C=C+"&autoplay=1",$.setAttribute("src",C),l?setTimeout(()=>{C=C.replace("autoplay=1","autoplay=0"),$.setAttribute("src",C)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(C){C.dataset.ecTrackingId&&C.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:C.id,tracking_id:C.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const C=z.dataset.width,I=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var A=document.querySelector(".ecom-modal."+E);if(A){const j=A.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:C,height:I};Object.assign(j.style,T)}},onClose:function(){var A=document.querySelector(".ecom-modal."+E);if(A){const j=A.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-n0f9y2f5r0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0f9y2f5r0s', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-by2s0o51guu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-by2s0o51guu', settings: {"loop":false,"player_controls":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-72z288t4yil"]=  window.__ectimmers["ecom-72z288t4yil"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-72z288t4yil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72z288t4yil', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ad766ni0ofh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ad766ni0ofh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oe2fod03k5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oe2fod03k5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk3mzg71kui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk3mzg71kui', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjx363ofhpk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjx363ofhpk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5flcb9b4xl5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5flcb9b4xl5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pgrajh4le9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pgrajh4le9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iuktezch2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iuktezch2j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ag1y3amkzkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ag1y3amkzkl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njwjync7pvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njwjync7pvc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5ox70g83t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5ox70g83t9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uttt11z5wy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uttt11z5wy', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t98vcgiz2i9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t98vcgiz2i9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9v7d1a34hqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9v7d1a34hqq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-elstg95k987').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-elstg95k987', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6y4jxg7mk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6y4jxg7mk8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3aif9wzptun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3aif9wzptun', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-basw6zob9y8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-basw6zob9y8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfmilfciy0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfmilfciy0p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fabii4ifzcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fabii4ifzcv', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13xgk3htv71').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13xgk3htv71', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-alaq9smn2w7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-alaq9smn2w7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9c4ktpjx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9c4ktpjx8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsc702fapyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsc702fapyi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yei5pvcuv2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yei5pvcuv2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vn14kvkb8w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vn14kvkb8w', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcb8dcasaro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcb8dcasaro', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3h4s8jwlk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3h4s8jwlk8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugax9mc6ca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugax9mc6ca', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbczgfeqp3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbczgfeqp3o', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvgtofgzz1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvgtofgzz1m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlvy68dxgkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlvy68dxgkh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1m4rly1irl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1m4rly1irl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgr3nlknm95').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgr3nlknm95', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p6qlthhmp6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p6qlthhmp6', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yttr7i01cpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yttr7i01cpi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3us4kp5c2d8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3us4kp5c2d8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-787mclmxjp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-787mclmxjp9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xi7e0dgsxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xi7e0dgsxe', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfddvs3ukt4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfddvs3ukt4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fb2lvi0027').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fb2lvi0027', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fo4mglvfe9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fo4mglvfe9r', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qql8v3x6xrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qql8v3x6xrj', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1z02em3erq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1z02em3erq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tew3f9ygbge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tew3f9ygbge', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjgvozwv61j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjgvozwv61j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-otoambrea7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-otoambrea7f', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9fm9tcc4i4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9fm9tcc4i4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}